import React from 'react'

import { CSVReader } from '../CSVReader'
import { renderDescription, toTitleCase } from './helpers'
import './CsvInstructions.scss'

export const CsvInstructions = ({
  templateImageSrc,
  templateImageAlt,
  onDownloadTemplate,
  headersContent,
  extraItems = null,
  titlesAndDescriptions,
  onCsvLoaded,
}) => (
  <div>
    <button type="button" className="csv-instructions__template" onClick={onDownloadTemplate}>
      <span className="csv-instructions__template-ribbon">Click to Download Template</span>
      <img
        src={templateImageSrc}
        alt={templateImageAlt}
        className="csv-instructions__template-image"
      />
    </button>

    <div className="csv-instructions">
      <div className="csv-instructions__item">
        <div className="csv-instructions__header">
          <strong>Headers</strong>
        </div>
        <div className="csv-instructions__description">{headersContent}</div>
      </div>
      <ul className="csv-instructions__list">
        {extraItems}
        {Object.entries(titlesAndDescriptions).map(([key, getDescription]) => (
          <li key={key} className="csv-instructions__item">
            <div className="csv-instructions__header">
              <strong>{toTitleCase(key)}</strong>
            </div>
            <div className="csv-instructions__description">
              {renderDescription(getDescription())}
            </div>
          </li>
        ))}
      </ul>
    </div>
    <CSVReader onFileLoaded={onCsvLoaded} />
  </div>
)
